<highcharts-chart
  [Highcharts]="Highcharts"
  style="width: 100%; height: 400px; display: block"
  [options]="chartOptions"
  [(update)]="updateFlag"
></highcharts-chart>
